// src/pages/HomeRedirect.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function HomeRedirect() {
  const { loading, isAuth, user } = useAuth();

  // Mientras carga el estado desde localStorage, no navegamos
  if (loading) return null; // o un spinner si prefieres

  // Si no hay sesión, manda a login
  if (!isAuth || !user) return <Navigate to="/login" replace />;

  // ¿Es admin?
  const role = String(user?.role || "").toLowerCase();
  const rolesArr = Array.isArray(user?.roles) ? user.roles.map(r => String(r).toLowerCase()) : [];

console.log('User roles:', role, rolesArr);

  const isAdmin = role === "admin" || rolesArr.includes("admin");

  // Redirige según rol
  return <Navigate to={isAdmin ? "/reports" : "/leads"} replace />;
}
